import React from 'react';
import {
  titleUI,
  fileInputMultipleUI,
  fileInputMultipleSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import environment from 'platform/utilities/environment';
import content from '../../../utils/content.json';

const UploadMessage = (
  <p>
    <strong>Note:</strong> You can submit your supporting documents and
    additional evidence after submitting your application. You’ll need to submit
    them by mail or upload them using the Claim Status Tool.
  </p>
);

export default {
  uiSchema: {
    ...titleUI(
      content['additional-info-upload-documents-title'],
      content['additional-info-upload-documents-description'],
    ),
    files: fileInputMultipleUI({
      title: content['additional-info-upload-documents-files-title'],
      hint: content['additional-info-upload-documents-files-hint'],
      required: false,
      fileUploadUrl: `${environment.API_URL}/v0/claim_attachments`,
      maxFileSize: 103809024, // 99 MB for PDFs
      accept: '.pdf,.jpg,.jpeg,.png',
      formNumber: '21P-534EZ',
      disallowEncryptedPdfs: true,
    }),
    'view:uploadMessage': {
      'ui:description': UploadMessage,
    },
  },
  schema: {
    type: 'object',
    properties: {
      files: fileInputMultipleSchema(),
      'view:uploadMessage': {
        type: 'object',
        properties: {},
      },
    },
  },
};
